js_bread_pass()
function js_bread_pass(){
    document.addEventListener('DOMContentLoaded', initBreadPass)
}

// inicializar numero de pasos bread wine
function initBreadPass() {
    const buttons = document.querySelectorAll('.js-bread-pass')
    const urls = document.querySelectorAll('.js-bread-pass__url')
    const pass3 = document.querySelectorAll('.js-bread-pass__pass-3')
    const texts = document.querySelectorAll('.js-bread-pass__end')
    const nexts = document.querySelectorAll('.js-bread-pass__next')
    const prevs = document.querySelectorAll('.js-bread-pass__prev')

    if (buttons != null && texts != null){
        init()
    }

    function init(){
        if (localStorage.wine_pasos == '3') {
            buttons.forEach(button => {
                button.classList.add('d-none')
            }) 

            if (urls != null) {
                urls.forEach(url => {
                    url.href = '/pages/wine-assistant-4'
                })
            }

            if (pass3 != null) {
                pass3.forEach(pass => {
                    pass.innerHTML = '2'
                })
            }
            
            texts.forEach(text => {
                text.innerHTML = localStorage.wine_pasos
            })

            if (nexts != null) {
                nexts.forEach(next => {
                    next.href = '/pages/wine-assistant-4'
                    next.dataset.key = 'wine_3_tag'
                    next.dataset.local = 'wine_3'
                })
            }

            if (prevs != null) {
                prevs.forEach(prev => {
                    prev.innerHTML = `${localStorage.wine_1}`
                })
            }
        }
    }
}
